import { EnAuthOptionsOperator } from '../enums/auth-options-operator.enum';

export class AuthOptions {
  private readonly _id: string | Array<string> | null;
  private readonly _operator: EnAuthOptionsOperator;
  private _klass: string | Array<string> | undefined;
  private _disabled: boolean;
  private _require: boolean;
  private _readonly: boolean;
  private _style: any;
  private _exact: boolean;
  private _callback: (renderElement: any) => void;

  constructor(id: string | string[] | null = null, operator: EnAuthOptionsOperator = EnAuthOptionsOperator.AND, exact = false) {
    this._id = id;
    this._operator = operator;
    this._klass = undefined;
    this._disabled = false;
    this._require = false;
    this._readonly = false;
    this._style = undefined;
    this._exact = exact;
    this._callback = () => {};
  }

  get id(): string | Array<string> | null {
    return this._id;
  }

  get operator(): EnAuthOptionsOperator {
    return this._operator;
  }

  get klass(): string | Array<string> | undefined {
    return this._klass;
  }

  set klass(value: string | Array<string>) {
    if (typeof value === "string") value = [value];
    this._klass = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  get require(): boolean {
    return this._require;
  }

  set require(value: boolean) {
    this._require = value;
  }

  get readonly(): boolean {
    return this._readonly;
  }

  set readonly(value: boolean) {
    this._readonly = value;
  }

  get style(): any {
    return this._style;
  }

  set style(value: any) {
    this._style = value;
  }

  get exact(): boolean {
    return this._exact;
  }

  set exact(value: boolean) {
    this._exact = value;
  }

  get callback(): (renderElement: any) => void {
    return this._callback;
  }

  set callback(value: (renderElement: any) => void) {
    this._callback = value;
  }
}
